import { useRef } from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from './AboutSection';
import ApplyNowSection from './ApplyNowSection';
import CampusLife from './CampusLife';
import InquiryForm from './InquiryForm';
import PlacementsSection from './PlacementsSection';
import ProgramsOffered from './ProgramSection';
import TestimonialSlider from './TestimonialSlider';
import CompanySection from './CompanySection';
import AdmissionProcess from './AdmissionProcess';
import StudentTestimonials from './StudentTestimonials';
import StatsSection from './StatsSection';
import LogoCarousel from './LogoCarousel';
import PlacementDrive from './PlacementDrive';
// import Programmes from './Programmes';

import AnimatedSection from './AnimatedSection';

export default function LandingPage() {
  const mobileFormRef = useRef();
  const desktopFormRef = useRef();

  const scrollToInquiryForm = () => {
    // if (window.innerWidth < 768) {
    //   mobileFormRef.current?.scrollIntoView({ behavior: 'smooth' });
    // } else {
    //   desktopFormRef.current?.scrollIntoView({ behavior: 'smooth' });
    // }
    const header = document.querySelector('header');
    const headerHeight = header?.offsetHeight || 0;

    const refToScroll =
      window.innerWidth < 768 ? mobileFormRef : desktopFormRef;

    if (refToScroll.current) {
      const y =
        refToScroll.current.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        20; // optional spacing

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <HeroSection desktopFormRef={desktopFormRef} />

      <AnimatedSection>
        <div className="container mx-auto flex justify-center items-center px-4 md:px-10 top-[0] relative">
          <div className="flex justify-center w-full md:hidden mt-[40px] mb-[40px]">
            <InquiryForm ref={mobileFormRef} />
          </div>
        </div>
      </AnimatedSection>

      <AnimatedSection>
        <AboutSection />
      </AnimatedSection>

      <AnimatedSection>
        <ProgramsOffered />
      </AnimatedSection>

      <AnimatedSection>
        <ApplyNowSection onApplyClick={scrollToInquiryForm} />
      </AnimatedSection>

      <AnimatedSection>
        <PlacementsSection />
      </AnimatedSection>

      <AnimatedSection>
        <PlacementDrive />
      </AnimatedSection>

      <AnimatedSection>
        <TestimonialSlider />
      </AnimatedSection>

      <AnimatedSection>
        <CampusLife />
      </AnimatedSection>

      <AnimatedSection>
        <CompanySection />
      </AnimatedSection>

      <AnimatedSection>
        <AdmissionProcess onApplyClick={scrollToInquiryForm} />
      </AnimatedSection>

      <AnimatedSection>
        <LogoCarousel />
      </AnimatedSection>

      <AnimatedSection>
        <StudentTestimonials />
      </AnimatedSection>

      <AnimatedSection>
        <StatsSection onApplyClick={scrollToInquiryForm} />
      </AnimatedSection>

      {/* <Programmes /> */}

      {/* Other Sections Can Be Added Below */}
    </div>
  );
}
